import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, RouterEvent, NavigationEnd} from '@angular/router';
import { environment} from '../../../environments/environment'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CommonServiceService {
  
  private previousUrl: string = undefined;
  private currentUrl: string = undefined;

  constructor(private httpClient:HttpClient, private router: Router) { 
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {        
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      };
    });
  }

  /**
   * 
   * @param registerData 
   */
  register(registerData) {
    
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
          .post(environment.api.base + 'user/register', registerData,{
            headers,
            observe:'response'
          }).pipe(map(result => {
            return result.body;
          }));
  }
  
  /**
   * 
   * @param fileToUpload 
   */
  uploadCompanyLogo(fileToUpload: File): Observable<any> {  
    const formData: FormData = new FormData();
          formData.append('file', fileToUpload);
    return this.httpClient
      .post(environment.api.base + 'file/upload', formData)
      .pipe(map(res => res ));
  }

  /**
   * 
   * @param uploadzip
   */
   uploadZip(fileToUpload: File, categoryId, subCategoryId,metalId,orgId): Observable<any> {  
    const formData: FormData = new FormData();
          formData.append('file', fileToUpload);
          formData.append('organizationId', orgId);
          formData.append('categoryId', categoryId);
          formData.append('subcategoryId', subCategoryId);
          formData.append('metalId', metalId);

    return this.httpClient
      .post(environment.api.base + 'product/uploadFile', formData,{
        reportProgress: true,
        observe: 'events'
      })
      .pipe(map(res => res ));
  }
  /**
   * 
   * @param requestedData => email
   */
  getPlanDetails(requestedData:string){
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
      .post(environment.api.base + 'admin/subscription/getJewelleryPlans', {email:requestedData},{
        headers,
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }
  /**
   * 
   * @param requestedData => email
   */
   getPDPlanDetails(requestedData:string){
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
      .post(environment.api.base + 'user/getPlans', {email:requestedData},{
        headers,
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }
  /**
   * 
   * @param requestedData => email
   */
   getSubcategories(requestedData:string){
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
      .post(environment.api.base + 'admin/subcategory/getSubCategoryByCategoryId', {"categoryId":requestedData},{
        headers,
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }

    /**
   * 
   * @param requestedData => email
   */
     getMetalList(){
      let headers = new HttpHeaders()
        .set('Content-Type','application/json')
        .set('Accept-Language','en')
        .set('x-api-key','test');
  
      return this.httpClient
        .post(environment.api.base + 'metal/getAllMetals', { "organizationId": -1,},{
          headers,
          observe:'response'
        }).pipe(map(result => {
          return result.body;
        }));
    }

  /**
   * 
   * @param requestedData => email
   */
  getUserProfileDetails(requestedData:string){
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
      .post(environment.api.base + 'user/getUserProfile', {email:requestedData},{
        headers,
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }

   /**
   * 
   * @param requestedData => email
   */
    getCatogoriesList(requestedData:string){
      let headers = new HttpHeaders()
        .set('Content-Type','application/json')
        .set('Accept-Language','en')
        .set('x-api-key','test');
  
      return this.httpClient
        .post(environment.api.base + 'admin/category/getAllCategories', {email:requestedData},{
          headers,
          observe:'response'
        }).pipe(map(result => {
          return result.body;
        }));
    }

  /**
   * 
   * @param requestedData => email
   */
   UpdateUserProfileStep(requestedData:string,step){
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
      .post(environment.api.base + 'user/updateUserProfile', {'email':requestedData,'step':step},{
        headers,
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }

  /**
   * 
   * @param requestedData => email
   */
   UpdatePDUserProfileStep(requestedData:string,step){
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
      .post(environment.api.base + 'user/updateUserProfileForPD', {'email':requestedData,'step':step},{
        headers,
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }

  /**
   * 
   * @param requestedData => {
        "currencyCode": "string",
        "month": "string",
        "organizationId": 0,
        "organizationName": "string",
        "roleName": "string",
        "totalAmount": 0,
        "userName": "string"
      }
   */
   createInvoiceForLoggedUser(requestedData:object){
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
      .post(environment.api.base + 'admin/invoiceV1/createInvoice', requestedData,{
        headers,
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }

  /**
   * 
   * @param requestedData =>Email
   */
    downloadScriptAndQRCode(requestedData:string){
      let headers = new HttpHeaders()
        .set('Content-Type','application/json')
        .set('Accept-Language','en')
        .set('x-api-key','test');
  
      return this.httpClient
        .post(environment.api.base + 'admin/subscription/downloadJewelScripts', {"email": requestedData},{
          headers,
          observe:'response'
        }).pipe(map(result => {
          return result.body;
        }));
    }

    /**
   * 
   * @param requestedData =>Email
   */
     downloadPDScriptAndQRCode(requestedData:string){
      let headers = new HttpHeaders()
        .set('Content-Type','application/json')
        .set('Accept-Language','en')
        .set('x-api-key','test');
  
      return this.httpClient
        .post(environment.api.base + 'user/downloadScripts', {"email": requestedData},{
          headers,
          observe:'response'
        }).pipe(map(result => {
          return result.body;
        }));
    }

  /**
   * 
   * @param requestedData =>Email
   */
  getInvoiceDetails(requestedData:string, orgId:string){
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
      .post(environment.api.base + 'admin/invoiceV1/getInvoiceDetail', {"email": requestedData,"organizationId":orgId},{
        headers,
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }
  
  /**
   * 
   * @param orgId 
   * @returns 
   */
  getProductList(requesParam){
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
      .post(environment.api.base + 'product/getProductListPagination', requesParam,{
        headers,
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }

  /**
   * 
   * @param orgId 
   * @returns 
   */
   getProdLandingPageDetail(requesParam){
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
      .post(environment.api.base + 'product/getProdLandingPageDetail', requesParam,{
        headers,
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }

  /**
   * 
   * @param  
   * @returns 
   */
   getAllFIlter(){
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
      .post(environment.api.base + 'product/getAllProductStatusFilter', {"organizationId": -1},{
        headers,
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }

  /**
   * 
   * @param  requesParam
   * @returns 
   */
   activateDeactivateProduct(requesParam){
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
      .post(environment.api.base + 'product/activateAndDeactivateProduct', requesParam,{
        headers,
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }

  /**
   * 
   * @param  requesParam
   * @returns 
   */
   getAllCorruptedImages(requesParam){
    let headers = new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Accept-Language','en')
      .set('x-api-key','test');

    return this.httpClient
      .post(environment.api.base + 'product/getAllCorruptedSkuList', requesParam,{
        headers,
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }

  /**
   * 
   * @param url 
   * @returns 
   */
  download(url: string) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.httpClient.get(url, { headers: headers, responseType: 'blob' });
  }

  getPreviousUrl(){
    return this.previousUrl;
  }
  
  vtoJsonLoad() {
    const jsonFile = 'assets/config/config.vto.json';
    return this.httpClient
      .get(jsonFile, {
        observe:'response'
      }).pipe(map(result => {
        return result.body;
      }));
  }
}
